<template>
  <v-avatar
    class="agency-avatar elevation-6"
    :size="computedSize"
    :color="getColor"
    :class="{ editable: editable }"
  >
    <v-img :src="displayImage" alt="agency logo" v-if="displayImage" />
    <span class="white--text noselect" :style="textStyle" v-else-if="name">{{
      name[0].toUpperCase()
    }}</span>

    <v-btn
      v-if="editable"
      color="primary"
      class="edit-button"
      fab
      dark
      x-small
      :loading="isSelectingPhoto"
      @click.stop="onEditButtonClick"
    >
      <v-icon>mdi-pencil</v-icon>
    </v-btn>

    <input
      ref="uploader"
      class="d-none"
      type="file"
      accept="image/*"
      @change="onFileChanged"
    />
  </v-avatar>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 100
    },
    img: {
      type: String
    },
    onImageSelected: {
      type: Function,
      default: () => {}
    },
    name: {
      type: String,
      default: ""
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colors: [
        "#D2691E",
        "#DEB887",
        "#5F9EA0",
        "#B8860B",
        "#A9A9A9",
        "#A52A2A",
        "#DAA520",
        "#FF69B4",
        "#FFFFF0",
        "#4B0082",
        "#F0E68C",
        "#32CD32",
        "#3CB371",
        "#FFDEAD",
        "#FFA500",
        "#CD853F",
        "#800080",
        "#BC8F8F",
        "#A0522D",
        "#008080",
        "#FF6347",
        "#EE82EE",
        "#F5DEB3",
        "#00FF7F",
        "#FFFF00",
        "#9ACD32"
      ],
      selectedFile: null,
      isSelectingPhoto: false,
      selectedImage: null
    };
  },
  computed: {
    displayImage() {
      return this.selectedFile ? this.selectedImage : this.img;
    },
    getColor() {
      if (this.displayImage) return "transparent";
      if (!this.name) return "orange";
      const letterIndex = this.name[0].toUpperCase().charCodeAt() - 65;
      return this.colors[letterIndex % this.colors.length];
    },
    computedSize() {
      // Make avatar slightly smaller on mobile
      return this.$vuetify.breakpoint.xsOnly ? this.size * 0.8 : this.size;
    },
    textStyle() {
      return {
        fontSize: `${this.computedSize / 2}px`,
        fontWeight: "bold"
      };
    }
  },
  methods: {
    onEditButtonClick() {
      this.isSelectingPhoto = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelectingPhoto = false;
        },
        { once: true }
      );
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      if (e.target.files.length > 0) {
        this.selectedFile = e.target.files[0];
        this.selectedImage = URL.createObjectURL(this.selectedFile);
        this.onImageSelected(this.selectedFile);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.agency-avatar {
  position: relative;
  border: 3px solid white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease;

  &.editable:hover {
    transform: scale(1.05);
    cursor: pointer;
  }

  .v-image {
    border-radius: 50%;
  }

  .edit-button {
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(25%, 25%);
    z-index: 2;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease;

    &:hover {
      transform: translate(25%, 25%) scale(1.1);
    }
  }
}

@media (max-width: 600px) {
  .agency-avatar {
    border-width: 2px;

    .edit-button {
      width: 24px !important;
      height: 24px !important;

      .v-icon {
        font-size: 12px !important;
      }
    }
  }
}
</style>
